import { coerceArray } from "@angular/cdk/coercion";
import { ArrayHelper, StringHelper } from "apps/idl/src/helpers";
import { IdHelper } from "apps/idl/src/helpers/idHelper";
import { UserData } from "apps/idl/src/model/application/UserData";
import { EPrefix } from "apps/idl/src/model/EPrefix";
import { IStoreDocument } from "apps/idl/src/model/store/IStoreDocument";
import { C_PREFIX_TRAITEMENT } from "../../../app/app.constants";
import { IIdlPrestationIdBuilderParams } from "./iidl-prestation-id-builder-params";
import { PrestationsIdBuilder } from "../../prestation/models/prestation-id-builder";

export class IdlPrestationIdBuilder extends PrestationsIdBuilder<IIdlPrestationIdBuilderParams>{

	//#region METHODS

	public buildId(poParams: IIdlPrestationIdBuilderParams): string {
		return IdHelper.buildChildId(EPrefix.prestation,
			IdHelper.buildChildId(
				C_PREFIX_TRAITEMENT,
				IdHelper.buildVirtualNode([
					, // On injecte le guid du traitement ou le préfixe
					UserData.currentSite._id,
					this.buildPrestationDate(poParams.prestationDate),
					poParams.customerIdOrPrefix,
				]),
				IdHelper.getLastGuidFromId(poParams.traitementId)
			),
			poParams.prestationGuid
		);
	}

	public buildFilterFunction(poParams: IIdlPrestationIdBuilderParams): (poDoc: IStoreDocument) => boolean {
		const laTraitementsGuids: string[] = (StringHelper.isBlank(poParams.traitementId) ? poParams.traitementIds : coerceArray(poParams.traitementId))?.map(
			(psTraitementId: string) => IdHelper.getLastGuidFromId(psTraitementId)
		);

		return super.buildFilterFunction(poParams) ?? (ArrayHelper.hasElements(laTraitementsGuids) ?
			(poDoc: IStoreDocument) => laTraitementsGuids.includes(IdHelper.getLastGuidFromId(IdHelper.extractParentId(poDoc._id))) :
			undefined
		);
	}

	//#endregion

}
